/*
 * @Date: 2022-07-04 16:42:03
 * @LastEditors: chuhongguang
 */
import layout from './modules/layout'
import view from './modules/views'

export default {
  layout,
  view
}

